import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import GiftCardShopModal from './GiftCardShopModal';

// GiftCardShop — route wrapper for the shareable /gift-cards link. Renders the
// gift-card modal directly; closing returns to the salon page. The same modal
// is also opened in-page from the salon profile's Gift Cards section.
const GiftCardShop = () => {
  const { salonSlug, salonId } = useParams();
  const salonIdOrSlug = salonSlug || salonId;
  const history = useHistory();

  const goToSalon = () => {
    history.push(salonSlug ? `/book/${salonSlug}` : `/salon/${salonIdOrSlug}`);
  };

  return (
    <GiftCardShopModal
      salonIdOrSlug={salonIdOrSlug}
      salonSlug={salonSlug}
      onClose={goToSalon}
    />
  );
};

export default GiftCardShop;
